<template>
  <ValidationObserver ref="obs" v-slot="{ invalid, handleSubmit }">
    <v-card class="elevation-0">
      <v-card-title>{{ $t('sign_in') }}</v-card-title>

      <alert :config="alertConfig"></alert>

      <v-card-text>
        <VTextFieldWithValidation
          name="email"
          rules="required|email"
          v-model="email"
          prepend-icon="mdi-email-outline"
          :placeholder="$t('placeholders.email')"
          :label="`${$t('fields.email')} *`"
          autofocus
          dense
        />

        <VTextFieldWithValidation
          name="password"
          rules="required"
          v-model="password"
          :label="`${$t('fields.password')} *`"
          :placeholder="$t('placeholders.password')"
          prepend-icon="mdi-key"
          :append-icon="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
          :type="passwordVisible ? 'text' : 'password'"
          v-on:click:append="passwordVisible = !passwordVisible"
          v-on:keyup.enter="handleSubmit(signIn)"
          dense
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <submit-button
          color="secondary"
          :loading="submitButtonLoading"
          @click="handleSubmit(signIn)"
          :disabled="invalid || submitButtonLoading"
          >{{ $t('sign_in') }}</submit-button
        >
      </v-card-actions>
      <v-card-actions>
        <span>
          {{ $t('forgot_password') }}
          <a v-on:click="forgot">{{ $t('reset_password') }}</a>
        </span>
      </v-card-actions>
      <v-card-actions>
        <span>
          {{ $t('no_account') }}
          <a v-on:click="signUp">{{ $t('create_account') }}</a>
        </span>
      </v-card-actions>
      <v-card-actions class="justify-center">
        <v-btn color="transparent" class="text-none" @click="signInGoogle()">
          <v-icon class="mr-2">$vuetify.icons.google</v-icon>
          Iniciar sesión con Google
        </v-btn>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>

<script>
import { formMixin } from '../../mixins/formMixin';

export default {
  name: 'SignIn',
  mixins: [formMixin],
  data() {
    return {
      email: '',
      password: '',
      passwordVisible: false
    };
  },
  methods: {
    async signIn() {
      this.submitButtonLoading = true;
      this.alertConfig = this.setAlert({});
      try {
        await this.$store.dispatch('auth/signUserIn', {
          email: this.email,
          password: this.password
        });
      } catch (err) {
        this.setError(err);
      } finally {
        this.submitButtonLoading = false;
      }
    },
    signInGoogle() {
      this.$store
        .dispatch('auth/signUserInGoogle')
        .then(() => {})
        .catch(error => {
          this.setError(error);
        });
    },
    forgot() {
      this.$router.push({ path: '/forgot-password' });
    },
    signUp() {
      this.$router.push({ path: '/sign-up' });
    }
  }
};
</script>
